"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const common_1 = require("@epic-core/common");
const Message_1 = require("../message/Message");
const CardCalloutStyled_1 = __importDefault(require("./CardCalloutStyled"));
const CardCallout = ({ redeemLink, title, desc, imgSrc, extra, boxClass }) => {
    return (react_1.default.createElement(CardCalloutStyled_1.default, { className: `card-callout-box ${boxClass}` },
        react_1.default.createElement("div", { className: "card-callout-inner-container" },
            react_1.default.createElement("div", { className: "card-callout-inner-box text-box" },
                react_1.default.createElement("h2", null, Message_1.localizedMessage(title)),
                desc ? react_1.default.createElement("p", null, Message_1.localizedMessage(desc)) : null,
                react_1.default.createElement("p", null,
                    react_1.default.createElement("a", { href: `${redeemLink}?lang=${common_1.getLocale()}`, rel: "noopener noreferrer", className: "redeem-link" }, Message_1.localizedMessage('epic.code.redemption.posa.giftcard.go'))),
                extra ? extra : null),
            react_1.default.createElement("div", { className: "card-callout-inner-box image-box" },
                react_1.default.createElement("img", { className: "card-callout-image", alt: "card", src: imgSrc })))));
};
CardCallout.propTypes = {
    title: prop_types_1.default.string,
    desc: prop_types_1.default.string,
    redeemLink: prop_types_1.default.string,
    imgSrc: prop_types_1.default.string,
    extra: prop_types_1.default.node,
    boxClass: prop_types_1.default.string
};
exports.default = CardCallout;
//# sourceMappingURL=CardCallout.js.map